import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown, DropdownButton } from 'react-bootstrap'
import Select from 'react-select'

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'

import { httpOk, POST, PUT, GET } from 'helpers/api'
import { formatDate, regexPhoneNumber, returnSign, formatMoney } from 'helpers/helpers'

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [smsTemplates, setSmsTemplates] = useState([])
	const [clientTypes, setClientTypes] = useState([])
	const [regions, setRegions] = useState([])
	const [showModal, setShowModal] = useState(false)
	const [modalSMS, setModalSMS] = useState({ 'bool': false, 'message': '' })
	const [modalDeleteClient, setModalDeleteClient] = useState(false)
	const [selectedItem, setSelectedItem] = useState({})
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({
		search: '',
	})
	const [pagination, setPagination] = useState({
		url: '/clients',
		response: null
	})

	async function createUpdate(e) {
		e.preventDefault();

		var response;
		if (selectedItem.id) {
			response = await PUT('/clients', selectedItem, { loader: true })
		} else {
			response = await POST('/clients', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			setShowModal(false)
		}
	}

	async function sendSms(e) {
		e.preventDefault();
		var filterDataCopy = { ...filterData }
		filterDataCopy.message = modalSMS.message
		filterDataCopy.sms_template_id = modalSMS.sms_template_id

		var response = await POST('/sms/send-clients', filterDataCopy, { loader: true })

		if (httpOk(response)) {
			toggleModalSMS(false)
		}
	}

	async function searchWithFilter() {
		var filterDataCopy = { ...filterData }
		var filterUrl = "/clients"
		var urlParams = ""
		checkFilter()

		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page
		if (filterDataCopy.size)
			urlParams += returnSign(urlParams) + 'size=' + filterDataCopy.size
		filterDataCopy.urlParams = urlParams

		if (`/clients${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterData.url, 'response': response.data })
		}

		setFilterData(filterDataCopy)
	}

	function toggleDeleteModal(item) {
		setSelectedItem(item)
		setModalDeleteClient(true)
	}

	async function toggleModalSMS(bool) {
		if (bool) {
			var response = await GET('/helper/sms-templates?sms_type_id=1')
			if (httpOk(response)) setSmsTemplates(response.data)
		}
		setModalSMS({ ...modalSMS, 'bool': bool, 'message': '' })
	}

	async function deleteClient(e) {
		e.preventDefault();

		var sendData = { ...selectedItem }
		sendData.status = -1
		var response = await PUT('/clients-status', sendData, { loader: true })

		if (httpOk(response)) {
			searchWithFilter()
			toggleDeleteModal()
		}
	}

	function resetFilter() {
		var filterDataCopy = {
			start_date: null,
			end_date: null,
			search: '',
		}
		setFilterData(filterDataCopy)
	}

	function checkFilter() {
		if (
			filterData.pos_id === null &&
			filterData.start_date === null &&
			filterData.end_date === null &&
			filterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function paginate(page, size) {
		setFilterData({ ...filterData, 'page': page, 'size': size })
	}

	function toggleModal(bool, item = { 'gender': 1 }) {
		if (bool) setSelectedItem({ ...item })
		setShowModal(bool)
	}

	function handleInputChange(e) {
		var selectedItemCopy = { ...selectedItem }
		selectedItemCopy[e.target.name] = e.target.value
		setSelectedItem(selectedItemCopy)
	}

	async function getClientTypes() {
		const response = await GET('/helper/clients-types')
		if (httpOk(response)) setClientTypes(response.data)
	}

	async function getRegions() {
		const response = await GET('/regions')
		if (httpOk(response)) setRegions(response.data)
	}

	// Yassi hudud ro'yxatidan react-select variantlari (yo'l bilan)
	function regionOptions() {
		const byId = {}
		regions.forEach(r => { byId[r.id] = r })
		return regions.map(r => {
			const path = []
			let cur = r
			while (cur && cur.parent_id && byId[cur.parent_id]) { cur = byId[cur.parent_id]; path.unshift(cur.name) }
			return { value: r.id, name: r.name, path: path.join(' › ') }
		})
	}

	useEffect(() => {
		getClientTypes()
		getRegions()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter()
	}, [filterData.search, filterData.page, filterData.size]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('clients')} [{formatMoney(data?.total)}]
				</h4>
				<DropdownButton title={t('action')}>
					<Dropdown.Item onClick={() => toggleModal(true)}>
						{t('create')}
					</Dropdown.Item>
					<Dropdown.Item onClick={() => toggleModalSMS(true)}>
						{t('sms_sending')}
					</Dropdown.Item>
				</DropdownButton>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between mb-3">
						<div className="d-flex gap-2">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}>
								</FilterSearch>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'minWidth': '130px' }}>{t('phone')}</th>
									<th style={{ 'minWidth': '130px' }}>{t('phone')} (2)</th>
									<th style={{ 'width': '20%' }}>{t('name')}</th>
									<th style={{ 'width': '10%' }}>{t('type')}</th>
									<th style={{ 'width': '10%' }}>{t('region')}</th>
									<th style={{ 'width': '20%' }}>{t('note')}</th>
									<th style={{ 'width': '10%' }} className="text-nowrap text-end">{t('cheques')}</th>
									<th style={{ 'width': '10%' }} className="text-nowrap text-center">{t('date')}</th>
									<th style={{ 'width': '10%' }} className="text-nowrap text-center">{t('last_cheque')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center" title={item.id}>
											{item.row_number}
										</td>
										<td>{regexPhoneNumber(item.phone)}</td>
										<td>{regexPhoneNumber(item.phone2)}</td>
										<td>{item.name}</td>
										<td>{item.client_type_name}</td>
									<td>{item.region_name}</td>
										<td>{item.note}</td>
										<td className="td-ellipsis text-end">{item.count_cheques}</td>
										<td className="td-ellipsis text-center">{formatDate(item.created_at)}</td>
										<td className="td-ellipsis text-center">{formatDate(item.last_cheque_date)}</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false} centered backdrop="static"
				dialogClassName="update-modal-width" onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{selectedItem.id ?
							<>{t('edit')}</>
							:
							<>{t('create')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createUpdate(e)} autoComplete="off">
						<div className="form-group">
							<label>{t('name')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="name"
								value={selectedItem.name ?? ''}
								onChange={(e) => handleInputChange(e)} />
						</div>
						<div className="form-group">
							<label>{t('phone')}</label>
							<input type="number" className="form-control" name="phone"
								value={selectedItem.phone ?? ''}
								onChange={(e) => handleInputChange(e)} />
						</div>
						<div className="form-group">
							<label>{t('phone')} (2)</label>
							<input type="number" className="form-control" name="phone2"
								value={selectedItem.phone2 ?? ''}
								onChange={(e) => handleInputChange(e)} />
						</div>
						<div className="form-group">
							<label>{t('client_types')}</label>
							<Select
								isClearable
								options={clientTypes}
								value={clientTypes.find(option => option.id === selectedItem.client_type_id) || ''}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'client_type_id': option.id })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>

						<div className="form-group">
							<label>{t('region')}</label>
							<Select
								isClearable
								options={regionOptions()}
								value={regionOptions().find(o => o.value === selectedItem.region_id) || ''}
								onChange={(o) => setSelectedItem({ ...selectedItem, 'region_id': o?.value ?? null })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(o) => o.path ? `${o.name} — ${o.path}` : o.name}
								getOptionValue={(o) => o.value}
							/>
						</div>

						<div className="form-group">
							<label>{t('birthday')}</label>
							<input type="date" className="form-control" name="birthday"
								value={selectedItem.birthday ?? ''}
								onChange={(e) => handleInputChange(e)} />
						</div>
						{/* <div className="d-flex justify-content-between mb-2">
							<div className="d-flex gap-3">
								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setSelectedItem({ ...selectedItem, 'gender': 1 })}
										style={{ 'backgroundColor': selectedItem.gender === 1 ? 'black' : '' }}>
									</div>
									<span onClick={() => setSelectedItem({ ...selectedItem, 'gender': 1 })}>
										{t('man')}
									</span>
								</div>

								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setSelectedItem({ ...selectedItem, 'gender': 2 })}
										style={{ 'backgroundColor': selectedItem.gender === 2 ? 'black' : '' }}>
									</div>
									<span onClick={() => setSelectedItem({ ...selectedItem, 'gender': 2 })}>
										{t('woman')}
									</span>
								</div>
							</div>
						</div> */}

						<div className="form-group">
							<label>{t('note')}</label>
							<input type="text" className="form-control" name="note"
								value={selectedItem.note ?? ''}
								onChange={(e) => handleInputChange(e)} />
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}

			{/* MODAL DELETE */}
			<Modal show={modalDeleteClient} animation={false} centered dialogClassName="update-modal-width"
				backdrop="static" onHide={() => toggleDeleteModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('delete')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => deleteClient(e)} autoComplete="off">
						<h4>
							{t('delete')}?
						</h4>
						<h6 className="text-danger">
							{t('delete_text')}?
						</h6>
						<div className="d-flex gap-3 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleDeleteModal(false)}>{t('cancel')}</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL DELETE */}

			{/* MODAL SMS */}
			<Modal show={modalSMS.bool} animation={false} centered
				dialogClassName="update-modal-width" backdrop="static"
				onHide={() => toggleModalSMS(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('create')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={sendSms} autoComplete="off">
						<div className="form-group">
							<label>{t('sms_templates')}</label>
							<Select
								options={smsTemplates}
								value={smsTemplates.find(option => option.id === modalSMS.sms_template_id) || ''}
								onChange={(option) => setModalSMS({ ...modalSMS, 'sms_template_id': option.id, 'message': option.text })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>

						<div className="form-group">
							<label>{t("description")}</label>
							<textarea className="form-control" rows="5"
								disabled
								value={modalSMS.message}>
							</textarea>
							<span>{t("letters")} - {modalSMS.message.length}</span>
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalSMS(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL SMS */}
		</>
	)
}

export default Index
